export const menuLinks = {
  apiGuides: 'https://docs.goshippo.com/',
  apiReference: 'https://docs.goshippo.com/shippoapi/public-api/',
  clientLib: 'https://docs.goshippo.com/docs/guides_general/clientlibraries/',
  contact: 'https://goshippo.com/contact',
  contactSales: 'https://goshippo.com/products/api#contact-an-expert',
  customerSupport: 'https://support.goshippo.com/',
  postmanCollection:
    'https://god.gw.postman.com/run-collection/22332580-e3f0581d-41f8-4c5c-894e-d9e22a87f6a5?action=collection%2Ffork&source=rip_markdown&collection-url=entityId%3D22332580-e3f0581d-41f8-4c5c-894e-d9e22a87f6a5%26entityType%3Dcollection%26workspaceId%3Da131fa9b-fc39-440e-93bb-2586e9e1eb93',
};
